export default class EntitiesAutocompleteController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        if (!this.entities) {
            this.entities = [];
        }
    }

    getText(item) {
        if (this.textKey) {
            return item[this.textKey] || item;
        }
        return item;
    }

    added(entity) {
        this.onAdd(
            this.eventEmitter({
                entity
            })
        );
        this.changed();
    }

    removed(entity) {
        this.onRemove(
            this.eventEmitter({
                entity
            })
        );
        this.changed();
    }

    changed() {
        this.onChange(
            this.eventEmitter({
                entities: this.entities
            })
        );
    }

    search() {
        return this.onSearch(
            this.eventEmitter({
                query: this.query
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/common/entities-autocomplete/autocomplete.controller.js